"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function deriveCustoTypeInstance(_a) {
    var constructor = _a.constructor;
    if (typeof constructor === 'function' && constructor !== Object) {
        return new constructor();
    }
    return {};
}
exports.default = deriveCustoTypeInstance;
//# sourceMappingURL=deriveCustomTypeInstance.js.map


//////////////////
// WEBPACK FOOTER
// /Volumes/Eoo/Repositories/legance/wp-content/themes/legance/node_modules/helpful-merge/dist/deriveCustomTypeInstance.js
// module id = 46
// module chunks = 0